import { minutesForHumans } from "@/_shared/helpers/minutesForHumans";
import { differenceInMinutes, isSameDay, startOfISOWeek, endOfISOWeek, addDays } from "date-fns";
import $date from "@/admin/common/date-fns";
const format = $date.format;

export const getDuration = function(start, end) {
  return minutesForHumans(differenceInMinutes(end, start));
};

export const fromToForHumans = function(start, end) {
  start = $date.parseISO(start);
  end = $date.parseISO(end);

  let startTime, endTime, duration;

  if (isSameDay(end, start)) {
    startTime = format(start, "EEEE, d. MMM yyyy 'kell' HH:mm");
    endTime = format(end, "HH:mm");
    duration = " (" + getDuration(start, end) + ")";
  } else {
    const formatPattern = "d.MM.yy, HH:mm";
    startTime = format(start, formatPattern);
    endTime = format(end, formatPattern);
    return startTime + " - " + endTime;
  }

  return startTime + " - " + endTime + duration;
};

/**
 *
 *
 * @param {string} start
 * @param {string} end
 * @return {array} [{string}firstLine, {string}secondLine]
 */
export const fromToForHumansTwoLine = function(start, end) {
  start = $date.parseISO(start);
  end = $date.parseISO(end);

  let firstLine, secondLine;

  if (isSameDay(end, start)) {
    firstLine = format(start, "EEEE, d. MMM yyyy");
    secondLine = format(start, "HH:mm");
    secondLine += " - ";
    secondLine += format(end, "HH:mm");
    secondLine += " (" + getDuration(start, end) + ")";
  } else {
    const formatPattern = "d.MM.yy, HH:mm";
    firstLine = format(start, formatPattern);
    secondLine = format(end, formatPattern);
  }

  return [firstLine, secondLine];
};

/**
 * Gets full week start date (monday)
 * and end date (sunday) from input date.
 */
export const rangeWeek = function(input, formatPattern = "yyyy-MM-dd") {
  const date = $date.parseISO(input);
  const start = format(startOfISOWeek(date), formatPattern);
  const end = format(endOfISOWeek(date), formatPattern);
  return [start, end];
};

/**
 * Starts from picked date and selects
 * specified amount of days.
 */
export const rangeFrom = function(input, daysCount, formatPattern = "yyyy-MM-dd") {
  const date = $date.parseISO(input);
  const start = format(date, formatPattern);
  const end = format(addDays(date, daysCount), formatPattern);
  return [start, end];
};
